import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { Box, Typography, useTheme } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import copy from "copy-to-clipboard";
import { useState } from "react";

import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { setOpenDialog } from "../../../redux/features/dialogSlice";
import CustomButton from "../CustomButton";
import CheckCircle from "../../../media/images/icons/check-circle";

const CustomDialogBox = () => {
  const dispatch = useAppDispatch();
  const { openDialog, dialogStatus, dialogTitle, dialogDescription } =
    useAppSelector((state) => state.dialog);
  const [acceptCopy, setAcceptCopy] = useState(false);

  const theme = useTheme();

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    dispatch(setOpenDialog(false));
  };

  return (
    <Snackbar
      sx={{
        left: "50% !IMPORTANT",
        right: "auto !IMPORTANT",
        bottom: "50% !IMPORTANT",
        transform: "translate(-50% , 50%)",
        maxWidth: "450px",
        width: "100%",
        zIndex: 99999,
      }}
      open={openDialog}
      //   autoHideDuration={6000}
      onClose={handleClose}
      dir="ltr"
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
          mb: "66px",
          pr: "12px",
          pl: "12px",
        }}
      >
        <Box
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 15,
            top: 5,
            padding: "5px",
            cursor: "pointer",
          }}
        >
          <CloseRoundedIcon sx={{ color: "error.main" }} />
        </Box>

        <Box
          sx={{
            height: "auto",
            minHeight: "150px",
            direction: "rtl",
            backgroundColor: "bgColor.white",
            borderRadius: "15px",
            width: "100%",
            py: "12px",
            px: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            boxShadow: "0px 4px 25px 0px rgba(0, 0, 0, 0.25)",
            border: "1px solid",
            borderColor:
              dialogStatus === "error"
                ? "error.main"
                : dialogStatus === "success"
                ? "success.main"
                : "warning.main",
          }}
        >
          <Box sx={{ display: "flex", direction: "rtl", alignItems: "center" }}>
            {dialogStatus === "error" ? (
              <InfoRoundedIcon sx={{ color: "error.main", fontSize: "30px" }} />
            ) : dialogStatus === "success" ? (
              <CheckCircle color={theme.palette.success.main} size={30} />
            ) : (
              <InfoRoundedIcon
                sx={{ color: "warning.main", fontSize: "30px" }}
              />
            )}

            <Typography
              sx={{
                mr: "12px",
                fontSize: "18px",
                color:
                  dialogStatus === "error"
                    ? "error.main"
                    : dialogStatus === "success"
                    ? "success.main"
                    : " warning.main",
              }}
            >
              {dialogTitle}
            </Typography>
          </Box>
          {dialogDescription && (
            <Typography
              sx={{
                mt: "8px",
                fontWeight: "700",
                fontSize: "13px",
                color: "darkStatic.main",
              }}
            >
              {dialogDescription || ""}
            </Typography>
          )}
        </Box>
      </Box>
    </Snackbar>
  );
};
export default CustomDialogBox;
